module.exports = __webpack_public_path__ + "img/icon5.1a666c9.png";